import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import authService from "../../services/authService";
import { Table } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";

class CovidPrehled extends Component {
  state = { filterFirmaID: "1" };

  componentDidMount = async () => {
    const user = authService.getCurrentUser();
    if (user.covidAdmin !== "1") {
      this.setState({ filterNadrizenyLogin: user.login });
    }
    this.nahrajPrehled();
  };

  timer = false;

  filtruj = async (attr, val, run) => {
    await this.setState({ [attr]: val });
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (run) {
      this.nahrajPrehled();
    } else {
      this.timer = setTimeout(() => this.filtruj(attr, val, true), 1000);
    }
  };

  nahrajPrehled = async () => {
    const user = authService.getCurrentUser();
    const {
      hledatOsobu,
      pouzeBezPlanu,
      pouzeBezTestu,
      filterPracoviste,
      filterSystemizace,
      filterNadrizenyLogin,
      filterPouzePrimiPodrizeni,
      filterPozitivniOd,
      filterPozitivniDo,
      filterFirmaID,
    } = this.state;
    const { onChangeFilter } = this.props;
    const filter = {
      hledatOsobu,
      pouzeBezPlanu,
      pouzeBezTestu,
      filterSystemizace,
      filterPracoviste,
      filterNadrizenyLogin,
      filterPouzePrimiPodrizeni,
      filterPozitivniOd,
      filterPozitivniDo,
      filterFirmaID,
    };
    if (onChangeFilter) {
      onChangeFilter(filter);
    }
    if (user.covidAdmin === "1" || parseInt(user.pocetPodrizenych) > 0) {
      const prehled = await httpService.post(
        config.apiEndpoint + "covid/prehled.php",
        filter
      );
      this.setState({
        loaded: true,
        prehled: prehled.data.prehled,
        pracoviste: prehled.data.pracoviste,
        systemizace: prehled.data.systemizace,
        zamestnavatele: prehled.data.zamestnavatele,
        datum14dni: prehled.data.datum14dni,
        nadrizeni: prehled.data.nadrizeni,
        duvodNepritomnosti: prehled.data.duvodNepritomnosti,
        pojistovny: prehled.data.zdravotniPojistovna,
      });
    }
  };

  userChangeDetail = async (login, attr, val, save) => {
    let { prehled } = this.state;
    const index = prehled.findIndex((p) => p.login === login);
    prehled[index][attr] = val;
    this.setState({ prehled });
    if (save === true) {
      await httpService.post(config.apiEndpoint + "uzivatele/zmenaDetail.php", {
        login,
        attr,
        val,
      });
      this.nahrajPrehled();
    }
  };

  render() {
    const {
      loaded,
      prehled,
      show,
      hledatOsobu,
      pouzeBezPlanu,
      pouzeBezTestu,
      pracoviste,
      systemizace,
      zamestnavatele,
      filterPracoviste,
      filterSystemizace,
      filterNadrizenyLogin,
      filterPouzePrimiPodrizeni,
      filterPozitivniOd,
      filterPozitivniDo,
      filterFirmaID,
      nadrizeni,
      datum14dni,
      pojistovny,
      duvodNepritomnosti,
    } = this.state;

    let user = {};
    if (show) {
      const index = prehled.findIndex((p) => p.login === show);
      user = prehled[index];
    }

    const usr = authService.getCurrentUser();

    return (
      <React.Fragment>
        <Modal
          show={this.state.show}
          onHide={() => this.setState({ show: false })}
          style={{ marginTop: "30px" }}
        >
          <Modal.Header closeButton>Nastavení uživatele</Modal.Header>
          <Modal.Body>
            {user.jmeno}
            <div>
              <small>Mobil (vč. +420 a bez mezer!)</small>
              <input
                type="text"
                name="mobil"
                className="form-control"
                value={user.mobil}
                onChange={(e) =>
                  this.userChangeDetail(
                    user.login,
                    e.target.name,
                    e.target.value,
                    false
                  )
                }
                onBlur={(e) =>
                  this.userChangeDetail(
                    user.login,
                    e.target.name,
                    e.target.value,
                    true
                  )
                }
              />
            </div>
            <div className="pt-2 pb-2">
              <small>Nepřítomnost</small>
              <select
                name="nepritomen"
                className="form-control"
                value={user.nepritomen}
                onChange={(e) =>
                  this.userChangeDetail(
                    user.login,
                    e.target.name,
                    e.target.value,
                    true
                  )
                }
              >
                {duvodNepritomnosti &&
                  duvodNepritomnosti.map((d) => (
                    <option value={d.duvod_id} key={d.duvod_id}>
                      {d.nazev}
                    </option>
                  ))}
              </select>
            </div>
            {/*<div className="row">
              <div className="col-md-6">
                <small>Ukončení prac. poměru</small>
                <input
                  type="date"
                  name="ukonceniPomeru"
                  className="form-control"
                  value={user.ukonceniPomeru}
                  onChange={(e) =>
                    this.userChangeDetail(
                      user.login,
                      e.target.name,
                      e.target.value,
                      false
                    )
                  }
                  onBlur={(e) =>
                    this.userChangeDetail(
                      user.login,
                      e.target.name,
                      e.target.value,
                      true
                    )
                  }
                />
              </div>
              <div className="col-md-6">
                <small>Covid pozitivní</small>
                <input
                  type="date"
                  name="covidPozitivni"
                  className="form-control"
                  value={user.covidPozitivni}
                  onChange={(e) =>
                    this.userChangeDetail(
                      user.login,
                      e.target.name,
                      e.target.value,
                      false
                    )
                  }
                  onBlur={(e) =>
                    this.userChangeDetail(
                      user.login,
                      e.target.name,
                      e.target.value,
                      true
                    )
                  }
                />
              </div>
              <div className="col-md-6">
                <small>Datum očkování na Covid (1. dávka)</small>
                <input
                  type="date"
                  name="ockovaniCovid1"
                  className="form-control"
                  value={user.ockovaniCovid1}
                  onChange={(e) =>
                    this.userChangeDetail(
                      user.login,
                      e.target.name,
                      e.target.value,
                      false
                    )
                  }
                  onBlur={(e) =>
                    this.userChangeDetail(
                      user.login,
                      e.target.name,
                      e.target.value,
                      true
                    )
                  }
                />
              </div>
              <div className="col-md-6">
                <small>Datum očkování na Covid (2. dávka)</small>
                <input
                  type="date"
                  name="ockovaniCovid"
                  className="form-control"
                  value={user.ockovaniCovid}
                  onChange={(e) =>
                    this.userChangeDetail(
                      user.login,
                      e.target.name,
                      e.target.value,
                      false
                    )
                  }
                  onBlur={(e) =>
                    this.userChangeDetail(
                      user.login,
                      e.target.name,
                      e.target.value,
                      true
                    )
                  }
                />
              </div>
              <div className="col-md-6">
                <small>GDPR souhlas</small>
                <input
                  type="date"
                  name="gdprSouhlas"
                  className="form-control"
                  value={user.gdprSouhlas}
                  onChange={(e) =>
                    this.userChangeDetail(
                      user.login,
                      e.target.name,
                      e.target.value,
                      false
                    )
                  }
                  onBlur={(e) =>
                    this.userChangeDetail(
                      user.login,
                      e.target.name,
                      e.target.value,
                      true
                    )
                  }
                />
                </div>
            </div>*/}
          </Modal.Body>
        </Modal>
        {loaded ? (
          <div style={{ maxHeight: "70vh", overflow: "auto" }}>
            <div className="row pb-3">
              <div className="col-md-3">
                <input
                  type="text"
                  placeholder="Hledat osobu"
                  value={hledatOsobu}
                  className="form-control"
                  onChange={(e) => this.filtruj("hledatOsobu", e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <select
                  name="filterFirmaID"
                  value={filterFirmaID}
                  className="form-control"
                  onChange={(e) =>
                    this.filtruj(e.target.name, e.target.value, true)
                  }
                >
                  <option value="">Všechna místa</option>
                  {zamestnavatele &&
                    zamestnavatele.map((p) => (
                      <option value={p.firma_id} key={p.firma_id}>
                        {p.nazev}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                <select
                  name="filterPracoviste"
                  value={filterPracoviste}
                  className="form-control"
                  onChange={(e) =>
                    this.filtruj(e.target.name, e.target.value, true)
                  }
                >
                  <option value="">Všechna pracoviště</option>
                  {pracoviste &&
                    pracoviste.map((p) => (
                      <option value={p.cisloPrac} key={p.cisloPrac}>
                        {p.nazev}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                {" "}
                <select
                  name="filterSystemizace"
                  value={filterSystemizace}
                  className="form-control"
                  onChange={(e) =>
                    this.filtruj(e.target.name, e.target.value, true)
                  }
                >
                  <option value="">Všechny pozice</option>
                  {systemizace &&
                    systemizace.map((p) => (
                      <option value={p.systemizace} key={p.systemizace}>
                        {p.nazev}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <select
                  name="filterNadrizenyLogin"
                  value={filterNadrizenyLogin}
                  className="form-control"
                  onChange={(e) =>
                    this.filtruj(e.target.name, e.target.value, true)
                  }
                  disabled={usr.covidAdmin !== "1"}
                >
                  <option value="">Nadřízený</option>
                  {nadrizeni &&
                    nadrizeni.length > 0 &&
                    nadrizeni.map((l) => (
                      <option value={l.login} key={l.login}>
                        {l.jmeno}
                      </option>
                    ))}
                </select>
                <input
                  type="checkbox"
                  checked={filterPouzePrimiPodrizeni === "1"}
                  onChange={(e) =>
                    this.filtruj(
                      e.target.name,
                      e.target.checked ? "1" : "0",
                      true
                    )
                  }
                  name="filterPouzePrimiPodrizeni"
                />{" "}
                Pouze přímí podřízení
              </div>
              <div className="col-md-3">
                <input
                  type={
                    this.state.filterOdDatum || filterPozitivniOd
                      ? "date"
                      : "text"
                  }
                  placeHolder="Pozitivní test od"
                  value={filterPozitivniOd}
                  name="filterPozitivniOd"
                  className="form-control"
                  onFocus={() => this.setState({ filterOdDatum: true })}
                  onChange={(e) =>
                    this.filtruj(e.target.name, e.target.value, false)
                  }
                  onBlur={(e) =>
                    this.filtruj(e.target.name, e.target.value, true)
                  }
                />
                <button
                  className="btn btn-link"
                  onClick={() => {
                    this.filtruj("filterPozitivniOd", datum14dni, false);
                    this.filtruj("filterPozitivniDo", "", true);
                  }}
                >
                  Posledních 14 dní
                </button>
              </div>
              <div className="col-md-3">
                <input
                  type={
                    this.state.filterDoDatum || filterPozitivniDo
                      ? "date"
                      : "text"
                  }
                  placeHolder="Pozitivní test do"
                  value={filterPozitivniDo}
                  name="filterPozitivniDo"
                  className="form-control"
                  onFocus={() => this.setState({ filterDoDatum: true })}
                  onChange={(e) =>
                    this.filtruj(e.target.name, e.target.value, false)
                  }
                  onBlur={(e) =>
                    this.filtruj(e.target.name, e.target.value, true)
                  }
                />
              </div>
              <div className="col-md-3">
                <input
                  type="checkbox"
                  checked={pouzeBezPlanu}
                  onChange={(e) =>
                    this.filtruj("pouzeBezPlanu", e.target.checked, true)
                  }
                />{" "}
                Bez plánovaného testu
                <br />
                <input
                  type="checkbox"
                  checked={pouzeBezTestu}
                  onChange={(e) =>
                    this.filtruj("pouzeBezTestu", e.target.checked, true)
                  }
                />{" "}
                Bez platného testu
              </div>
            </div>
            <p>
              Počet záznamů:{" "}
              <span className="text-success">{prehled && prehled.length}</span>{" "}
              celkem, z toho s povinnou účastí{" "}
              <span className="text-danger">
                {prehled && prehled.filter((p) => p.nezvat !== "1").length}
              </span>
            </p>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Jméno</th>
                  <th>Dokončení očkování</th>
                  <th>Počet testů</th>
                  <th>Poslední test</th>
                  <th>Naplánované testy</th>
                  <th>Plán testů</th>
                  <th>Neúčasti na objednaných testech</th>
                  <th>Přehled neúčastí</th>
                  <th>Výzva přes SMS</th>
                </tr>
              </thead>
              <tbody>
                {prehled &&
                  prehled.length > 0 &&
                  prehled.map((p, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          onClick={() => this.setState({ show: p.login })}
                          variant="link"
                          style={{
                            padding: "0px",
                            margin: "0px",
                            textAlign: "left",
                          }}
                        >
                          {p.jmeno}
                        </Button>{" "}
                        {p.nezvat === "1" && (
                          <span className="badge badge-warning mr-1">
                            Testů se nemusí účastnit do {p.nezvatDo}
                          </span>
                        )}
                        {p.gdprSouhlas && p.gdprSouhlas !== "0000-00-00" && (
                          <span className="badge badge-success">
                            GDPR: {p.gdprSouhlas}
                          </span>
                        )}
                        <div>
                          <small>
                            <a
                              href="javascript:;"
                              onClick={() =>
                                this.filtruj("filterFirma", p.firma_id, true)
                              }
                            >
                              {p.firma}
                            </a>
                          </small>
                        </div>
                        <div>
                          <small>
                            <a
                              href="javascript:;"
                              onClick={() =>
                                this.filtruj(
                                  "filterPracoviste",
                                  p.cisloPrac,
                                  true
                                )
                              }
                            >
                              {p.pracoviste}
                            </a>
                            :{" "}
                            <a
                              href="javascript:;"
                              onClick={() =>
                                this.filtruj(
                                  "filterSystemizace",
                                  p.systemizace,
                                  true
                                )
                              }
                            >
                              {p.pozice}
                            </a>
                          </small>
                        </div>
                      </td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {p.pocetDavek ? (
                          p.pocetDavek + " / " + p.posledniDavka
                        ) : (
                          <span className="text-danger">Neočkován</span>
                        )}
                      </td>
                      {p.pocetNavstev > 0 ? (
                        <td className="text-right">{p.pocetNavstev}</td>
                      ) : (
                        <td className="text-center text-danger" colSpan={2}>
                          Ještě netestován
                        </td>
                      )}
                      {p.pocetNavstev > 0 && (
                        <td>
                          {p.posledniNavsteva}
                          <div
                            className={
                              p.dnyOdPosledniNavstevy > 7
                                ? "text-danger"
                                : p.dnyOdPosledniNavstevy >= 5
                                ? "text-warning"
                                : "text-success"
                            }
                          >
                            před {p.dnyOdPosledniNavstevy} dny
                          </div>
                        </td>
                      )}
                      {p.pocetPlan > 0 ? (
                        <td className="text-right">{p.pocetPlan}</td>
                      ) : (
                        <td colSpan={2} className="text-center text-danger">
                          Bez plánovaných termínů
                        </td>
                      )}
                      {p.pocetPlan > 0 && (
                        <td className="text-center">
                          {p.datumyPlan &&
                            p.datumyPlan.map((d) => <div key={d}>{d}</div>)}
                        </td>
                      )}
                      {p.pocetNeucasti > 0 ? (
                        <td className="text-right">{p.pocetNeucasti}</td>
                      ) : p.pocetNavstev > 0 ? (
                        <td className="text-success text-center" colSpan={2}>
                          Vždy dorazil
                        </td>
                      ) : (
                        <td className="text-warning text-center" colSpan={2}>
                          Kde nic není... :o)
                        </td>
                      )}
                      {p.pocetNeucasti > 0 && (
                        <td className="text-center">
                          {p.datumyNeucasti &&
                            p.datumyNeucasti.map((d) => <div key={d}>{d}</div>)}
                        </td>
                      )}
                      <td>
                        {p.datumOdeslani ? (
                          <React.Fragment>
                            {p.datumOdeslani}
                            <div style={{ fontSize: "0.6em" }}>{p.zprava}</div>
                          </React.Fragment>
                        ) : (
                          <span className="text-info">Zatím bez upomínky</span>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        ) : (
          "Loading..."
        )}
      </React.Fragment>
    );
  }
}

export default CovidPrehled;
